// modules
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import {
  FaFacebook,
  FaYoutube,
  FaList,
  FaArrowsAltH,
  FaImage,
  FaUserCircle
} from 'react-icons/fa';

// X公式ロゴSVGコンポーネント
const XIcon = ({ className, style, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    style={style}
    width="16px"
    height="16px"
    {...props}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

// styles
import { TypeGroupUl } from '../../../styles/home';
import {
  ModalAppButton,
  ModalCancelButton
} from '../../../styles/app';

class CreateModal extends React.Component {

  render() {
    const {
      isOpen,
      toggle,
      types,
      isRestricted,
      handleSelectedComponentType,
      handleCreateComponentConfirmed
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>新しいアイテムを追加</ModalHeader>
        <ModalBody>
        <p>アイテムはカレンダーとタイトルを除き６件まで登録できます。</p>
        <TypeGroupUl className='list-group'>
          {types.map((type) => {
            switch (type.name) {
              case 'twitter':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <XIcon/> X
                  </li>
                )
              case 'facebook':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <FaFacebook/> Facebook
                  </li>
                )
              case 'youtube':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <FaYoutube/> Youtube
                  </li>
                )
              case 'information':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <FaList/> Information
                  </li>
                )
              case 'separator':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className='list-group-item'
                    onClick={handleSelectedComponentType}>
                    <FaArrowsAltH/> Title
                  </li>
                )
              case 'photo':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <FaImage/> Photo
                  </li>
                )
              case 'contact':
                return (
                  <li
                    data-type-id={type.id}
                    key={type.id}
                    className={'list-group-item ' + (isRestricted ? 'disabled' : '')}
                    onClick={isRestricted ? null : handleSelectedComponentType}>
                    <FaUserCircle/> Contact
                  </li>
                )
            }
          })}
        </TypeGroupUl>
        </ModalBody>
        <ModalFooter>
          <ModalAppButton onClick={handleCreateComponentConfirmed}>OK</ModalAppButton>
          <ModalCancelButton onClick={toggle}>キャンセル</ModalCancelButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CreateModal;
